import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Heading-3-Paragraph-Styles-Heading--Streamline-Flex"
    >
        <desc>
            {
                'Heading 3 Paragraph Styles Heading Streamline Icon: https://streamlinehq.com'
            }
        </desc>
        <g id="heading-3-paragraph-styles-heading">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.6831 11.7364c0.4078 1.1539 2.8168 0.9756 2.8168 -0.3598l0 -0.1799c0 -0.5961 -0.4832 -1.0793 -1.0793 -1.0793l-0.3598 0h0.2698c0.5465 0 0.9894 -0.443 0.9894 -0.98942 0 -1.23172 -2.1675 -1.3787 -2.4812 -0.26984"
                strokeWidth={1}
            />
            <path
                id="Vector 1"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 12.501V1.50098m7 0V12.501m-7 -5.95836c2.35186 -0.28937 4.64814 -0.28937 7 0"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
